import eventEmitter from "event-emitter";

class PlayerPubSub {}

eventEmitter(PlayerPubSub.prototype);

const playerPubSub = new PlayerPubSub();

export const publish = (...args) => playerPubSub.emit(...args);

export const subscribe = (...args) => playerPubSub.on(...args);

export const unsubscribe = (...args) => playerPubSub.off(...args);
